export default class PostRuleDataModel {
    securityRuleId: number;
    read: boolean;
    create: boolean;
    update: boolean;
    delete: boolean;
}
